import { defineComponent } from "vue";
export default defineComponent({
    name: 'SymbolPaw',
    props: {
        preventAnimation: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: '#333333'
        },
    },
    computed: {
        cssClasses() {
            const classes = [];
            if (this.preventAnimation) {
                classes.push('preventAnimation');
            }
            return classes.join(' ');
        }
    }
});
